import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesEventosCbba } from "./imagenesEventosCbba";

function Revista() {
  return <PaginaPublica titulo="Eventos Cochabamba" imagenes={imagenesEventosCbba} />;
}

export default Revista;